export * from './course.store';
export * from './department.store';
export * from './designation.store';
export * from './staff.store';

